'use strict';
var React = require('react');

var Tree = require('./Tree');

var MobilePreviewPanel = React.createClass({
  propTypes: {
    app: React.PropTypes.object,
    current: React.PropTypes.object,
    showPanel: React.PropTypes.bool.isRequired,
    onOpenPage: React.PropTypes.func.isRequired
  },
  render: function () {
    var app = this.props.app;
    var style = {};
    if (this.props.showPanel) {
      style.marginLeft = 0;
    } else {
      style.marginLeft = -200;
    }
    return (
      <div className="mobile-preview-panel preview-panel" style={style}>
        <div className="header">
          <h1>{app.name}</h1>
        </div>
        <div className="pages">
          <Tree
            name={this.props.app.name}
            current={this.props.current}
            modules={app.modules}
            onSelectPage={this.props.onOpenPage}/>
        </div>
      </div>
    );
  }
});

module.exports = MobilePreviewPanel;


// WEBPACK FOOTER //
// ./src/views/MobilePreviewPanel.jsx